export default "__VITE_ASSET__DAzwlVtE__"